module.exports = __webpack_public_path__ + "img/IMG_0240.c882cd90.png";